<template>
  <main
    id="create-item-page"
    class="page-container"
    v-if="
      $route.name === 'tiles-add-item' || $route.name === 'sanitary-add-item'
    "
  >
    <!-- messaggi di stato -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <form class="create-item-form" @submit.prevent="onSubmit">
      <!-- riga base -->
      <div class="create-item-row">
        <div class="field">
          <label for="category">Categoria *</label>
          <div v-if="$route.name === 'tiles-add-item'">
            <!-- <input type="hidden" v-model="form.category" value="piastrelle" /> -->
            <span>Piastrelle</span>
          </div>
          <!-- <select
            v-if="$route.name === 'tiles-add-item'"
            id="category"
            v-model="form.category"
            required
          >
            <option value="piastrelle">Piastrelle</option>
          </select> -->
          <div v-else-if="$route.name === 'sanitary-add-item'">
            <!-- <input type="hidden" v-model="form.category" value="sanitari" /> -->
            <span>Sanitari</span>
          </div>
          <!-- <select
            v-else-if="$route.name === 'sanitary-add-item'"
            id="category"
            v-model="form.category"
            required
          >
            <option value="sanitari">Sanitari</option>
          </select> -->
          <!-- <select id="category" v-model="form.category" required>
            <option disabled value="">— scegli —</option>
            <option value="piastrelle">Piastrelle</option>
            <option value="sanitari">Sanitari</option>
          </select> -->
        </div>
      </div>

      <hr />

      <!-- ---------------- PIASTRELLE ---------------- -->
      <template v-if="$route.name === 'tiles-add-item'">
        <div class="create-item-row">
          <div class="field">
            <label for="item-name">Nome articolo *</label>
            <input
              id="item-name"
              type="text"
              v-model.trim="form.itemName"
              placeholder="es. Avenue Grey 60x60"
              required
            />
          </div>
          <div class="field">
            <label for="boxQuantity">Box totali *</label>
            <input
              id="boxQuantity"
              type="number"
              min="0"
              v-model.number="form.boxQuantity"
              required
            />
          </div>

          <div class="field">
            <label for="piecesPerBox">Pezzi per box *</label>
            <input
              id="piecesPerBox"
              type="number"
              min="1"
              v-model.number="form.piecesPerBox"
              required
            />
          </div>

          <div class="field">
            <label for="widthCm">Larghezza (cm) *</label>
            <input
              id="widthCm"
              type="number"
              step="any"
              min="1"
              v-model.number="form.widthCm"
              required
            />
          </div>

          <div class="field">
            <label for="heightCm">Altezza (cm) *</label>
            <input
              id="heightCm"
              type="number"
              step="any"
              min="1"
              v-model.number="form.heightCm"
              required
            />
          </div>
        </div>

        <div class="create-item-row">
          <div class="field">
            <label for="brandTile">Brand</label>
            <input id="brandTile" type="text" v-model="form.brand" />
          </div>

          <div class="field">
            <label for="price">Prezzo €/box *</label>
            <input
              id="price"
              type="number"
              min="0"
              step="0.01"
              v-model.number="form.price"
            />
          </div>
        </div>
      </template>

      <!-- ---------------- SANITARI ---------------- -->
      <template v-if="$route.name === 'sanitary-add-item'">
        <div class="create-item-row">
          <div class="field">
            <label for="fixtureType">Tipo sanitari *</label>
            <AppSelect
              id="fixtureType"
              v-model="form.fixtureType"
              :options="fixtureTypeOptions"
              placeholder="— scegli —"
              required
            />
          </div>

          <div class="field">
            <label for="fixturePosition">Posizione *</label>
            <AppSelect
              id="fixturePosition"
              v-model="form.fixturePosition"
              :options="fixturePositionOptions"
              placeholder="— scegli —"
              required
            />
          </div>
        </div>
        <div class="create-item-row">
          <div v-if="form.fixtureType === 'vaso'" class="field">
            <label for="potQuantity">Pezzi Coprivaso *</label>
            <input
              id="potQuantity"
              type="number"
              min="0"
              v-model.number="form.potQuantity"
              required
            />
          </div>
          <div class="field">
            <label for="inWarehouse">Quantità pezzi *</label>
            <input
              id="inWarehouse"
              type="number"
              v-model="form.inWarehouse"
              placeholder="inserisci"
            />
          </div>
        </div>
        <div class="create-item-row">
          <div class="field">
            <label for="color">Colore</label>
            <input
              id="color"
              type="text"
              v-model="form.color"
              placeholder="es. Bianco lucido"
            />
          </div>

          <div class="field">
            <label for="brandFixture">Brand *</label>
            <input id="brandFixture" type="text" v-model="form.brand" />
          </div>
        </div>
        <div class="create-item-row">
          <div class="field">
            <label for="subBrand">Linea / Serie</label>
            <input id="subBrand" type="text" v-model="form.subBrand" />
          </div>
          <div class="field">
            <label for="price">Prezzo *</label>
            <input
              id="price"
              type="number"
              step="any"
              v-model="form.price"
              placeholder="inserisci"
            />
          </div>
        </div>
      </template>

      <!-- ---------------- MEDIA ---------------- -->
      <!-- <div class="create-item-row">
        <div class="field">
          <label for="image">Immagine</label>
          <input id="image" type="file" accept="image/*" @change="onImage" />
        </div>
      </div> -->

      <!-- submit -->
      <div class="save-button-container">
        <button
          id="create-item-button"
          type="submit"
          :disabled="!canSaveItem"
          :aria-disabled="!canSaveItem"
          :title="
            !canSaveItem
              ? 'Compila tutti i campi obbligatori'
              : `${
                  $route.name === 'tiles-add-item'
                    ? 'Crea piastrella'
                    : 'Crea sanitario'
                }`
          "
        >
          Salva
        </button>
      </div>
    </form>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { isTileValid, isSanitaryValid } from "@/utilities/itemValidation";

export default {
  name: "CreateItemPage",
  data() {
    return {
      // [sc-49210] Opzioni dei menu a tendina
      fixtureTypeOptions: [
        { value: "vaso", label: "Vaso" },
        { value: "bidet", label: "Bidet" },
        { value: "lavabo", label: "Lavabo" },
        { value: "box doccia", label: "Box doccia" },
        { value: "piatto doccia", label: "Piatto doccia" },
        { value: "vasca", label: "Vasca" },
        { value: "mobile bagno", label: "Mobile bagno" },
        { value: "specchiera", label: "Specchiera" },
        { value: "rubinetteria", label: "Rubinetteria" },
        { value: "idraulica", label: "Idraulica" },
        { value: "altro", label: "Altro" },
      ],
      fixturePositionOptions: [
        { value: "sospeso", label: "Sospeso" },
        { value: "terra", label: "A terra" },
        { value: "mono-blocco", label: "Mono-blocco" },
        { value: "altro", label: "Altro" },
      ],
      errorMessage: "",
      successMessage: "",
      form: {
        /* comuni */
        itemName: "",
        category:
          this.$route.name === "tiles-add-item" ? "piastrelle" : "sanitari",
        brand: "",
        subBrand: "",
        inWarehouse: 0,
        color: "",
        price: 0,
        image: null,

        /* piastrelle */
        boxQuantity: 0,
        piecesPerBox: 0,
        widthCm: 0,
        heightCm: 0,

        /* sanitari */
        fixtureType: "",
        fixturePosition: "",
        potQuantity: 0,
      },
    };
  },
  computed: {
    isTilesRoute() {
      return this.$route.name === "tiles-add-item";
    },
    isSanitaryRoute() {
      return this.$route.name === "sanitary-add-item";
    },

    // [sc-49210] regole in utilities/itemValidation.js, uguali in modifica
    tilesValid() {
      return !this.isTilesRoute || isTileValid(this.form);
    },

    sanitaryValid() {
      return !this.isSanitaryRoute || isSanitaryValid(this.form);
    },

    // abilita il submit solo se le regole del ramo corrente sono rispettate
    canSaveItem() {
      return this.tilesValid && this.sanitaryValid;
    },
  },
  methods: {
    ...mapActions(["uploadImage", "createItem"]),
    resetForm() {
      this.form = {
        itemName: "",
        category: "",
        brand: "",
        subBrand: "",
        color: "",
        image: null,
        boxQuantity: 0,
        piecesPerBox: 0,
        inWarehouse: 0,
        widthCm: 0,
        heightCm: 0,
        price: 0,
        fixtureType: "",
        fixturePosition: "",
        potQuantity: 0,
      };
    },
    onImage(e) {
      this.form.image = e.target.files[0] || null;
    },
    async onSubmit() {
      // console.log("form: ", this.form);
      this.errorMessage = "";
      this.successMessage = "";

      let imageUrl = "";
      if (this.form.image) {
        try {
          const upRes = await this.uploadImage({ image: this.form.image });
          imageUrl = upRes.data.url;
        } catch (e) {
          this.errorMessage = "Impossibile caricare l'immagine.";
          return;
        }
      }

      const payload = { ...this.form, image: imageUrl || null };
      console.log("payload: ", payload);
      if (payload.category === "piastrelle") {
        delete payload.fixtureType;
        delete payload.fixturePosition;
      }
      // console.log("payload: ", payload);

      try {
        const res = await this.createItem(payload);
        const itemId = res.data.item.id;
        // console.log("itemId", itemId);
        // console.log("res: ", res);
        this.successMessage =
          res.data?.message ||
          `${
            this.$route.name === "tiles-add-item" ? "Piastrella" : "Sanitario"
          } creata/o con successo!`;
        this.$toast.success(this.successMessage);
        this.resetForm();
        const routeName =
          this.$route.name === "tiles-add-item"
            ? "tiles-edit-item"
            : "sanitary-edit-item";
        setTimeout(
          () => this.$router.push({ name: routeName, params: { itemId } }),
          800
        );
      } catch (err) {
        this.errorMessage =
          err.response?.data?.message ||
          err.response?.data?.error ||
          "Errore durante la creazione.";
        this.$toast.error(this.errorMessage);
      }
    },
  },
};
</script>

<style src="@/css/CreateItemPage.css"></style>
